import { Base } from '@gate31/core/src/libs/BaseComponent';

export class SnippetProductDesk extends Base<HTMLElement> {
    static cn = new Base.BuildCn('SnippetProductDesk');
}
